(function () {
  var defaultProviderSelectors = [
    "[data-prizma-login-trigger]",
    ".prizma-login-trigger",
    "[data-trueotp-login]",
    ".trueotp-login",
    "[data-authyo-login]",
    ".authyo-login",
    "[data-miniorange-login]",
    ".mo-otp-login",
    "[data-otp-login-trigger]",
    ".otp-login-trigger"
  ];

  var modal = null;
  var phoneStep = null;
  var otpStep = null;
  var phoneInput = null;
  var countrySelect = null;
  var otpInput = null;
  var statusNode = null;
  var otpStatusNode = null;
  var phoneDisplay = null;
  var lastFocused = null;

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = window.getComputedStyle(element);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function getProviderTrigger() {
    for (var i = 0; i < defaultProviderSelectors.length; i += 1) {
      var candidate = document.querySelector(defaultProviderSelectors[i]);
      if (candidate && isVisible(candidate)) return candidate;
    }
    return null;
  }

  function setStep(step) {
    if (!phoneStep || !otpStep) return;
    phoneStep.hidden = step !== "phone";
    otpStep.hidden = step !== "otp";
  }

  function normalizePhone(value) {
    return String(value || "").replace(/[^\d]/g, "");
  }

  function fullPhone() {
    var country = countrySelect ? countrySelect.value : "+971";
    return country + normalizePhone(phoneInput && phoneInput.value);
  }

  function showStatus(node, message) {
    if (!node) return;
    if (!message) {
      node.hidden = true;
      node.textContent = "";
      return;
    }
    node.hidden = false;
    node.textContent = message;
  }

  function isWhatsappLoginEnabled() {
    return !!(modal && modal.getAttribute("data-wa-enabled") === "true");
  }

  function goToEmailLogin() {
    var emailUrl =
      (modal && modal.getAttribute("data-email-url")) || "/account/login";
    window.location.href = emailUrl;
  }

  function openModal() {
    if (!modal) return;
    if (!isWhatsappLoginEnabled()) {
      goToEmailLogin();
      return;
    }
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("wa-login-open");
    setStep("phone");
    showStatus(statusNode, "");
    showStatus(otpStatusNode, "");
    if (otpInput) otpInput.value = "";
    setTimeout(function () {
      if (phoneInput) phoneInput.focus();
    }, 20);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("wa-login-open");
    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus();
    }
  }

  function handleOpenClick(event) {
    var trigger = event.currentTarget;
    var provider = getProviderTrigger();

    if (provider && provider !== trigger) {
      event.preventDefault();
      provider.click();
      return;
    }

    event.preventDefault();
    if (!isWhatsappLoginEnabled()) {
      goToEmailLogin();
      return;
    }
    openModal();
  }

  function handleSend() {
    var phone = normalizePhone(phoneInput && phoneInput.value);
    if (!phone || phone.length < 7) {
      showStatus(
        statusNode,
        (document.documentElement.lang || "").indexOf("ar") === 0
          ? "يرجى إدخال رقم واتساب صحيح."
          : "Please enter a valid WhatsApp number."
      );
      if (phoneInput) phoneInput.focus();
      return;
    }

    showStatus(statusNode, "");
    if (phoneDisplay) phoneDisplay.textContent = fullPhone();
    showStatus(otpStatusNode, "");
    setStep("otp");
    setTimeout(function () {
      if (otpInput) otpInput.focus();
    }, 20);
  }

  function handleVerify() {
    var code = String((otpInput && otpInput.value) || "").replace(/[^\d]/g, "");
    if (code.length < 4) {
      showStatus(
        otpStatusNode,
        (document.documentElement.lang || "").indexOf("ar") === 0
          ? "يرجى إدخال رمز التحقق."
          : "Please enter the verification code."
      );
      return;
    }

    showStatus(otpStatusNode, "");
  }

  function handleResend() {
    showStatus(otpStatusNode, "");
  }

  function bindModal() {
    modal = document.getElementById("WhatsappLoginModal");
    if (!modal) return;

    phoneStep = modal.querySelector('[data-wa-step="phone"]');
    otpStep = modal.querySelector('[data-wa-step="otp"]');
    phoneInput = document.getElementById("WhatsappLoginPhone");
    countrySelect = document.getElementById("WhatsappLoginCountry");
    otpInput = document.getElementById("WhatsappLoginOtp");
    statusNode = modal.querySelector("[data-wa-status]");
    otpStatusNode = modal.querySelector("[data-wa-otp-status]");
    phoneDisplay = modal.querySelector("[data-wa-phone-display]");

    modal.querySelectorAll("[data-wa-login-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    var sendBtn = modal.querySelector("[data-wa-send]");
    if (sendBtn) sendBtn.addEventListener("click", handleSend);

    var verifyBtn = modal.querySelector("[data-wa-verify]");
    if (verifyBtn) verifyBtn.addEventListener("click", handleVerify);

    var resendBtn = modal.querySelector("[data-wa-resend]");
    if (resendBtn) resendBtn.addEventListener("click", handleResend);

    var backBtn = modal.querySelector("[data-wa-back]");
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        setStep("phone");
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function bindOpenTriggers() {
    document
      .querySelectorAll("[data-whatsapp-login-open], [data-whatsapp-login-trigger]")
      .forEach(function (trigger) {
        trigger.addEventListener("click", handleOpenClick);
      });
  }

  function init() {
    bindModal();
    bindOpenTriggers();
  }

  document.addEventListener("DOMContentLoaded", init);

  window.PerfyraWhatsappLogin = {
    open: openModal,
    close: closeModal
  };
})();
